var _rect, _rect2, _use, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGbNir(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-gb-nir",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 512,
    width: 512,
    rx: 0,
    ry: 0,
    fill: "#fff",
    fillRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "a",
    y: 204.8,
    ry: 0,
    rx: 0,
    height: 102.4,
    width: 512,
    fill: "#c00",
    fillRule: "evenodd"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    height: 300,
    width: 600,
    transform: "matrix(0 1 -.9375 0 496 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.205 156.384c3.08-5.142 1.239-8.462-3.42-9.488 0 0-14.867 5.084-30.924 5.642-16.056.558-35.132-4.308-35.132-4.308-3.421 2.29-2.586 7.724-.89 11.116 0 0 16.809 5.957 35.944 5.372 12.153-.371 23.67-3.68 30.13-5.872 3.712-1.26 4.294-2.404 4.292-2.462z",
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.539
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 389.552l-30.857-64.106-70.946 5.33L258.285 272l-40.088-58.776 70.946 5.33L320 154.448l30.857 64.106 70.946-5.33L381.715 272l40.088 58.776-70.946-5.33z",
    transform: "matrix(1 0 0 1.06667 -64 -34.133)",
    fill: "#fff",
    stroke: "#161111",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.54 130.376c38.763 6.816 37.378 8.747 37.378 8.747l10.117-32.26s1.065-6.362-1.704-10.224-10.543-1.704-10.543-1.704-1.065-5.225-4.472-6.475c-3.408-1.25-16.08 4.885-20.021 6.248-3.94 1.363-5.964 2.726-11.501 2.613-5.538-.114-15.442-5.34-17.252-6.362-1.81-1.022-4.473-2.044-6.922-1.93-2.45.113-5.005.794-6.283 2.612-1.278 1.817-1.278 4.09-1.278 4.09s-2.024-1.364-5.218-1.364c-3.195 0-5.006.455-6.497 2.272-1.49 1.818-3.407 6.93-3.407 6.93l3.62 8.746.213 12.04 7.561 12.723 36.208-6.702z",
    fill: "#b02320",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.347
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.674 148.602s1.952 2.483 1.877 3.364c-.075.88-.901 1.681-.901 1.681s.6.64.45 1.602c-.15.96-1.35 1.04-1.35 1.04s.224.881-.526 1.282c-.751.4-3.829 1.12-3.829 1.12s-15.014-4.563-31.078-4.563c-16.065 0-34.983 5.525-34.983 5.525s-1.951-.721-2.026-2.082c-.075-1.362.225-2.322.225-2.322s-1.069.118-1.351-.881c-.396-1.398.15-2.483.15-2.483s-.745.256.075-1.601c.6-1.361 1.501-1.842 1.501-1.842s16.815-6.406 35.958-6.486c19.143-.08 35.808 6.486 35.808 6.646z",
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.539
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.229 108.262s-.641-2.325.769-4.376c1.41-2.052 3.974-1.915 4.744-1.505.769.41.64 1.368 1.666 1.641 1.026.274 1.795-.547 1.795-.547",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.185
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M305.824 113.705l-5.822 12.849-2.289.428s-1.396-.895-5.38-.6c-2.851.215-3.694.986-3.694.986l5.18-12.807s.403 2.752 1.003 4.37c.763 2.055 3.654 3.982 3.654 3.982s.4-2.459-.361-5.44c-.843-3.297-2.81-7.751-2.81-7.751l10.52 3.983z",
    fill: "#fc0",
    fillOpacity: 0.941,
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.239
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#121116",
    stroke: "#121116",
    strokeWidth: 1.208,
    strokeLinejoin: "round",
    d: "M252.492 73.771h6.516v29.541h-6.516z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.56 128.251l4.185 9.551s17.81-7.405 38.833-7.267c31.534.208 40.489 6.956 40.489 6.956l4.671-11.835-3.503 2.18-3.602 2.388-4.087 1.66-4.964-.415-4.38-3.425-2.238-4.984-3.699 3.634-6.52 1.557-6.424-1.765-5.645-7.578s-4.205 8.424-9.539 8.928c-7.688.727-12.165-3.945-12.165-3.945s-2.859 6.852-7.592 8.098c-7.494 1.972-13.723-3.738-13.82-3.738z",
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.023
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.243
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 59.851 -67.617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.512 71.89s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 51.676 -63.54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.337 75.967s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 69.343 -70.008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.004 69.5s2.72-.05 2.997-1.23c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 80.035 -67.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.696 71.794s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 88.184 -60.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.845 78.957s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 91.705 -48.798)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.366 90.71s2.72-.05 2.997-1.23c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 90.401 -36.906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.062 102.601s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 85.446 -26.475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.107 113.032s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 43.722 -60.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.383 79.097s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.682
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.43616 0 0 .46523 70.33 -38.804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.028 77.86s2.274-.04 2.506-1.027c.23-.987-.155-2.262-.155-2.262s1.08 1.275.771 2.262c-.308.987-.61 1.242-1.387 1.44-.527.133-1.311-.083-1.735-.412z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.682
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.43616 0 0 .46523 70.363 -35.023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.06 81.642s2.275-.041 2.507-1.028c.23-.987-.155-2.262-.155-2.262s1.08 1.275.771 2.262c-.308.987-.61 1.242-1.387 1.44-.527.133-1.311-.083-1.735-.412z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.682
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.43616 0 0 .46523 70.558 -29.46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.256 87.205s2.274-.041 2.506-1.028c.23-.987-.155-2.262-.155-2.262s1.08 1.275.771 2.262c-.308.987-.61 1.242-1.387 1.44-.527.133-1.311-.083-1.735-.412z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.47168 0 0 .50313 55.552 -32.923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.21 93.246s2.46-.044 2.71-1.112c.25-1.067-.167-2.446-.167-2.446s1.167 1.379.834 2.446c-.334 1.068-.661 1.343-1.501 1.557-.57.144-1.418-.09-1.876-.445z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 34.4 -38.158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.061 101.35s2.72-.05 2.997-1.23c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.388
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.48982 0 0 .52248 47.727 -13.514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.025 117.507s2.554-.046 2.814-1.154c.26-1.108-.173-2.54-.173-2.54s1.212 1.432.866 2.54c-.347 1.108-.687 1.395-1.559 1.616-.591.15-1.472-.092-1.948-.462z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 24.956 -60.507)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.617 79s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 16.613 -64.017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.274 75.49s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 8.622 -68.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.283 71.48s2.72-.05 2.997-1.23c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 -.544 -70.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.117 69.347s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 -11.355 -67.402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.306 72.105s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 -18.994 -59.254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.667 80.253s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 -22.166 -47.847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.495 91.66s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 -20.756 -35.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.905 103.567s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.52155 0 0 .55632 -15.586 -25.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.075 114.347s2.72-.049 2.997-1.229c.276-1.18-.185-2.704-.185-2.704s1.291 1.524.922 2.704c-.368 1.18-.73 1.485-1.66 1.721-.629.16-1.566-.098-2.074-.492z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.832
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.31597 -.0903 .13499 .53737 45.39 32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.318 128.724s1.636-.519 1.517-1.707c-.118-1.187-.767-2.58-.767-2.58s1.151 1.249 1.214 2.453c.063 1.204-.082 1.56-.587 1.95-.343.263-.974.176-1.377-.116z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.832
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    transform: "matrix(.31758 .08362 -.125 .54011 195.933 -42.884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.342 127.777s1.667.388 2.101-.713c.434-1.102.495-2.656.495-2.656s.444 1.687-.046 2.774-.778 1.325-1.397 1.405c-.42.054-.932-.347-1.153-.81z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.722 57.4l.243 6.078s-6.757.633-7.033 1.293c-1.313 3.139 1.576 7.373 1.576 7.373s2.272-1.81 8.003-1.81c5.457 0 8.246 1.422 8.246 1.422s1.455-2.458 1.455-4.268c0-1.811-.606-3.622-.606-3.622s-2.79-.388-3.638-.388h-2.425l-.243-6.208-5.578.13z",
    fill: "#b3a192",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.208
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M262.359 66.83c0 .682-.54 1.235-1.207 1.236a1.22 1.22 0 0 1-1.211-1.23 1.223 1.223 0 0 1 1.201-1.242 1.223 1.223 0 0 1 1.217 1.226m2.785.672c0 .711-.563 1.289-1.26 1.29-.695.002-1.26-.573-1.264-1.284a1.278 1.278 0 0 1 1.255-1.296c.695-.004 1.263.569 1.269 1.28m-5.574-.699c0 .682-.54 1.235-1.207 1.236-.666.002-1.209-.55-1.211-1.23a1.223 1.223 0 0 1 1.201-1.242 1.222 1.222 0 0 1 1.217 1.226m-5.59.077c0 .71-.56 1.285-1.255 1.286-.694.002-1.258-.571-1.26-1.28-.004-.71.556-1.288 1.25-1.292.694-.005 1.26.566 1.266 1.276m-3.103.23c0 .71-.561 1.286-1.255 1.287-.694.002-1.259-.572-1.261-1.281-.003-.71.556-1.287 1.25-1.292.694-.004 1.26.567 1.266 1.276m5.695-3.711c0 .598-.474 1.084-1.06 1.085a1.074 1.074 0 0 1-1.063-1.08 1.074 1.074 0 0 1 1.055-1.09 1.073 1.073 0 0 1 1.068 1.076m0-5.035c0 .598-.474 1.084-1.06 1.085a1.074 1.074 0 0 1-1.063-1.08 1.074 1.074 0 0 1 1.055-1.09 1.073 1.073 0 0 1 1.068 1.076m0 2.724c0 .6-.474 1.085-1.06 1.086a1.074 1.074 0 0 1-1.063-1.08 1.074 1.074 0 0 1 1.055-1.09 1.073 1.073 0 0 1 1.068 1.076m-8.839 6.96c0 .684-.542 1.24-1.212 1.241-.67.002-1.214-.551-1.217-1.236a1.228 1.228 0 0 1 1.207-1.246 1.226 1.226 0 0 1 1.222 1.23",
    fill: "#f0ddcb",
    stroke: "#121116",
    strokeWidth: 0.616,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M256.845 66.518c0 .749-.595 1.356-1.331 1.358a1.346 1.346 0 0 1-1.336-1.353 1.346 1.346 0 0 1 1.325-1.363 1.346 1.346 0 0 1 1.342 1.347",
    fill: "#916c68",
    stroke: "#4d3126",
    strokeWidth: 0.616,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.534
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.628 247.41c0 3.607-2.88 6.533-6.44 6.54-3.558.007-6.45-2.907-6.465-6.515-.014-3.607 2.856-6.545 6.415-6.566 3.558-.021 6.462 2.882 6.49 6.49",
    transform: "matrix(.386 0 0 .41173 91.842 -53.386)",
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeWidth: 3.031,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.412 49.862s2.013-.036 2.218-.91c.204-.873-.137-2.001-.137-2.001s.955 1.128.683 2.002c-.273.873-.541 1.099-1.229 1.273-.466.119-1.16-.073-1.535-.364z",
    fill: "#a3afb8",
    fillRule: "evenodd"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.967 138.811s2.222 2.212 2.815 4.188c.592 1.975 1.481 7.269 1.481 7.269s23.259-6.874 34.666-6.321c11.407.553 37.702 6.716 37.702 6.716s.444-3.003.963-6.163c.518-3.16 2.666-6.637 2.666-6.637s-25.11-8.375-40.961-7.585c-15.851.79-23.777 2.607-27.332 3.793-3.556 1.185-12.222 4.82-12 4.74z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.539
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250.661 38.45h10.004s-2.469 1.823-2.971 3.558c-.432 1.493-.303 3.945-.303 3.945s2.728 0 3.94-1.1c1.213-1.1 3.76-3.04 3.76-3.04v13.581s-2.456-2.532-3.941-3.362c-1.785-.998-3.577-1.359-3.577-1.359s0 2.2.848 3.493c.85 1.293 4.244 6.208 4.244 6.208l-14.308.582s3.394-3.817 4.79-6.596c.91-1.811.545-3.687.545-3.687s-2.425 0-3.637.906c-1.213.905-3.335 3.621-3.335 3.621V42.137s.91 2.522 2.91 3.492c2.001.97 3.88.453 3.88.453s.389-2.6-.424-4.204c-.838-1.654-2.607-3.492-2.425-3.427z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.208
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M249.877 81.545s-7.116-.091-13.204-3.933c-6.088-3.84-12.228-7.864-21.264-5.578-1.85.468-8.66 3.658-11.66 13.992-2.106 7.252.343 16.005 2.486 19.938 2.144 3.933 5.6 7.919 5.6 7.919l3.676-2.656s-9.362-8.464-8.247-19.439c1.115-10.975 6.259-13.535 6.259-13.535s6.345-5.305 14.833-.275c8.489 5.03 16.805 7.317 16.805 7.317s7.803 2.012 8.489 1.92c.686-.091-3.944-5.761-3.773-5.67z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.208
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M210.515 122.709l-3.78-7.928 11.343-4.729s-2.738 3.895-3.39 6.676c-.796 3.398-.522 6.259-.522 6.259s1.043-.835 2.347-3.06c.99-1.689 2.608-7.789 2.608-7.789l5.085 17.386c.04.046-2.614-2.789-4.48-3.125-2.103-.38-4.647.343-4.647.343l-2.999.974-1.565-5.007z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.239
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M262.703 81.402s7.117-.091 13.204-3.933c6.088-3.84 12.228-7.864 21.264-5.578 1.85.468 8.66 3.658 11.66 13.992 2.106 7.252-.342 16.005-2.486 19.938-2.143 3.933-3.601 6.246-3.601 6.246l-4.419-1.692s8.106-7.755 6.991-18.73c-1.114-10.975-6.259-13.535-6.259-13.535s-6.345-5.305-14.833-.275c-8.488 5.03-16.805 7.317-16.805 7.317s-7.803 2.012-8.489 1.92c-.685-.091 3.945-5.761 3.773-5.67z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.208
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#121116",
    strokeWidth: 1.208,
    strokeLinejoin: "round",
    d: "M259.028 73.89h2.971v29.554h-2.971zm-10.004-.129h3.516v29.554h-3.516z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M265.212 66.906c0 5.243-4.331 9.496-9.681 9.506-5.35.011-9.699-4.225-9.72-9.468-.021-5.243 4.293-9.513 9.643-9.544 5.35-.031 9.715 4.188 9.758 9.431",
    fill: "#fc0",
    stroke: "#121116",
    strokeWidth: 1.208,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246.907 103.197l16.681-.147s-1.956 1.245-3.638 4.43c-1.682 3.186-1.442 5.2-1.442 5.2s2.54-.037 4.325-1.428c1.785-1.392 3.776-3.991 3.776-3.991l-.069 16.402s-1.201-2.087-3.192-3.332c-1.99-1.244-4.805-1.244-4.805-1.244h-5.698s-2.605.164-3.776.988c-1.65 1.163-3.707 3.405-3.707 3.405l-.274-15.487s.823 2.71 3.5 3.808c2.678 1.098 4.188.952 4.188.952s0-3.478-1.373-5.272-4.496-4.21-4.496-4.284z",
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.023
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.201 116.076s2.441 6.075 5.279 8.756c1.652 1.56 6.619 2.736 8.864 2.124 5.047-1.374 8.515-5.68 8.515-5.68s-.18 4.717 2.979 7.317c3.16 2.6 5.687 3.274 8.304 2.504 2.618-.77 10.02-6.644 10.02-6.644l1.535 1.444s-4.245 4.398-8.707 6.732c-2.297 1.202-9.27.534-11.527-1.392-2.257-1.926-3.597-6.592-3.597-6.592s-1.39 3-4.368 4.06c-2.98 1.058-7.073 1.012-10.874-.172-2.558-.798-5.881-4.562-6.513-5.813-.632-1.252-.451-1.926-.451-1.926s-1.875 5.731-5.777 7.295c-3.686 1.476-7.887 1.488-11.457.393-3.608-1.107-3.89-3.259-3.89-3.259s-.27 6.066-8.123 7.8c-7.854 1.733-14.082-4.43-14.082-4.43l1.083-1.733s4.423 5.296 11.193 4.814c6.77-.481 9.027-9.725 9.027-9.725s2.979 4.815 10.923 4.911c7.943.096 10.2-10.977 10.2-10.977l1.444.193z",
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.97
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.569 336.292s.114-5.3 1.253-6.894c1.616-2.259 3.814-2.35 4.935-2.036 1.384.387 2.82 1.645 2.585 5.326-.235 3.682-1.253 5.484-.156 6.894 1.096 1.41 1.253 2.35 3.368 2.037 2.115-.314 3.055-1.019 2.585-2.977-.47-1.958-1.097.157-1.488-1.488-.392-1.645 2.046-8.752 1.645-13.16-.392-4.31-2.037-7.756-5.327-8.618-3.092-.81-5.719-.783-8.617 1.332-2.78 2.028-6.345 8.695-6.345 8.695l-.079 14.257 5.797-.313-.156-3.055z",
    fillRule: "evenodd",
    transform: "matrix(.52155 0 0 .55632 60.047 -67.478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.77 340.13s-2.217-4.816-3.897-5.823c-2.382-1.428-4.435-.636-5.338.099-1.114.907-1.93 2.633-.248 5.916 1.683 3.283 3.335 4.53 2.891 6.26-.443 1.73-.212 2.654-2.277 3.21s-3.208.284-3.557-1.7c-.35-1.983 1.068-.293.771-1.958-.296-1.665-5.364-7.21-6.754-11.414-1.358-4.108-1.223-7.925 1.451-10.026 2.513-1.975 4.933-2.998 8.434-2.213 3.358.752 9.285 5.445 9.285 5.445l5.755 13.045-5.442 2.023-1.074-2.864z",
    fillRule: "evenodd",
    transform: "matrix(.52155 0 0 .55632 60.047 -67.478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.662 297.907s-5.64 9.479-4.387 16.764c1.253 7.285 8.773 22.953 8.773 22.953l.079 2.115 4.057-.439-.924-2.146s2.027-18.756.783-24.676c-.924-4.401-8.303-14.492-8.381-14.57zm9.008 43.398s2.818 3.373 6.189 5.014c3.682 1.793 5.195 1.805 6.658.705 1.072-.806.705-4.23-.548-5.17-1.253-.94-2.675-.463-2.898.47-.377 1.574-.89 1.47-2.037.861-1.674-.887-5.562-3.29-5.562-3.29l-1.802 1.41zm-4.366.765s-1.186 4.233-3.586 7.112c-2.622 3.146-3.997 3.778-5.783 3.376-1.308-.295-2.379-3.569-1.621-4.94.757-1.372 2.25-1.52 2.836-.761.99 1.281 1.415.975 2.21-.05 1.163-1.496 3.723-5.283 3.723-5.283l2.221.547z",
    fillRule: "evenodd",
    transform: "matrix(.52155 0 0 .55632 60.047 -67.478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.094 341.932c0 1.253-3.953 2.27-8.835 2.272-4.882.002-8.85-1.01-8.87-2.263-.018-1.253 3.92-2.273 8.801-2.28 4.882-.008 8.865 1 8.904 2.253",
    transform: "matrix(.51436 -.09206 .0863 .54866 32.973 -35.18)",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.569 336.292s.114-5.3 1.253-6.894c1.616-2.259 3.814-2.35 4.935-2.036 1.384.387 2.82 1.645 2.585 5.326-.235 3.682-1.253 5.484-.156 6.894 1.096 1.41 1.253 2.35 3.368 2.037 2.115-.314 3.055-1.019 2.585-2.977-.47-1.958-1.097.157-1.488-1.488-.392-1.645 2.046-8.752 1.645-13.16-.392-4.31-2.037-7.756-5.327-8.618-3.092-.81-5.719-.783-8.617 1.332-2.78 2.028-6.345 8.695-6.345 8.695l-.079 14.257 5.797-.313-.156-3.055z",
    fillRule: "evenodd",
    transform: "matrix(.48843 .1951 -.1829 .521 177.775 -120.468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.77 340.13s-2.217-4.816-3.897-5.823c-2.382-1.428-4.435-.636-5.338.099-1.114.907-1.93 2.633-.248 5.916 1.683 3.283 3.335 4.53 2.891 6.26-.443 1.73-.212 2.654-2.277 3.21s-3.208.284-3.557-1.7c-.35-1.983 1.068-.293.771-1.958-.296-1.665-5.364-7.21-6.754-11.414-1.358-4.108-1.223-7.925 1.451-10.026 2.513-1.975 4.933-2.998 8.434-2.213 3.358.752 9.285 5.445 9.285 5.445l5.755 13.045-5.442 2.023-1.074-2.864z",
    fillRule: "evenodd",
    transform: "matrix(.48843 .1951 -.1829 .521 177.775 -120.468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.662 297.907s-5.64 9.479-4.387 16.764c1.253 7.285 8.773 22.953 8.773 22.953l.079 2.115 4.057-.439-.924-2.146s2.027-18.756.783-24.676c-.924-4.401-8.303-14.492-8.381-14.57zm9.008 43.398s2.818 3.373 6.189 5.014c3.682 1.793 5.195 1.805 6.658.705 1.072-.806.705-4.23-.548-5.17-1.253-.94-2.675-.463-2.898.47-.377 1.574-.89 1.47-2.037.861-1.674-.887-5.562-3.29-5.562-3.29l-1.802 1.41zm-4.366.765s-1.186 4.233-3.586 7.112c-2.622 3.146-3.997 3.778-5.783 3.376-1.308-.295-2.379-3.569-1.621-4.94.757-1.372 2.25-1.52 2.836-.761.99 1.281 1.415.975 2.21-.05 1.163-1.496 3.723-5.283 3.723-5.283l2.221.547z",
    fillRule: "evenodd",
    transform: "matrix(.48843 .1951 -.1829 .521 177.775 -120.468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.094 341.932c0 1.253-3.953 2.27-8.835 2.272-4.882.002-8.85-1.01-8.87-2.263-.018-1.253 3.92-2.273 8.801-2.28 4.882-.008 8.865 1 8.904 2.253",
    transform: "matrix(.51196 .1062 -.09955 .5461 141.803 -100.348)",
    strokeLinejoin: "round"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.09 138.529s.487 2.18 1.655 1.038c1.167-1.142 17.227-7.89 39.904-7.89 22.677 0 37.568 6.644 38.444 7.06.876.415 1.266.934 2.044 0 .779-.935-.778-2.388-.778-2.388s-15.767-7.163-40.391-7.06c-24.624.104-40.586 7.579-40.586 7.579s-1.07.83-.292 1.661z",
    fill: "#cca715",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.539
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.846 148.59s.724-2.145 1.987-2.558c1.007-.329 2.598.728 2.598.728s-1.916-.188-2.516.175c-.541.329-.705 1.304-.705 1.304s.411-.777 1.881-.702c1.47.075 1.634.075 1.634.075s-2.492.201-3.068.966c-.576.765 2.351 1.116 2.351 1.116s-4.48.025-5.067-.263c-.588-.289-.964-1.267-1.964-.966-.999.301-2.022 1.254-2.022 1.254s1.14-2.044 1.858-2.056c.717-.013 1.14-.05 1.787.263s1.246.665 1.246.665zm-16.749 3.87s.339-2.25 1.509-2.905c.933-.523 2.68.202 2.68.202s-1.917.193-2.443.669c-.475.43-.467 1.42-.467 1.42s.27-.845 1.727-1.06c1.457-.217 1.62-.249 1.62-.249s-2.416.689-2.85 1.554c-.433.866 2.505.633 2.505.633s-4.398.908-5.025.74c-.628-.167-1.167-1.054-2.097-.56-.93.492-1.77 1.63-1.77 1.63s.766-2.233 1.469-2.387c.703-.154 1.112-.274 1.802-.094.69.18 1.34.408 1.34.408zm30.875-4.663s.84-2.097 2.123-2.43c1.024-.267 2.554.886 2.554.886s-1.903-.306-2.52.02c-.56.294-.776 1.258-.776 1.258s.453-.75 1.916-.585c1.463.166 1.627.176 1.627.176s-2.499.047-3.115.775c-.617.728 2.286 1.26 2.286 1.26s-4.473-.252-5.044-.577c-.571-.324-.894-1.324-1.908-1.085-1.014.239-2.086 1.127-2.086 1.127s1.25-1.97 1.966-1.938c.716.031 1.14.02 1.77.373.628.353 1.207.74 1.207.74zm14.144 1.707s1.062-1.978 2.374-2.15c1.045-.138 2.44 1.198 2.44 1.198s-1.857-.54-2.507-.294c-.587.223-.907 1.153-.907 1.153s.532-.689 1.967-.342c1.435.347 1.597.377 1.597.377s-2.487-.265-3.18.382c-.691.646 2.134 1.535 2.134 1.535s-4.415-.807-4.947-1.2c-.532-.393-.742-1.426-1.776-1.315-1.033.11-2.196.86-2.196.86s1.457-1.802 2.165-1.68c.709.12 1.131.161 1.717.59.586.429 1.119.886 1.119.886zm14.044 2.674s.99-1.506 2.055-1.542c.85-.029 1.879 1.154 1.879 1.154s-1.455-.58-1.994-.432c-.487.133-.808.855-.808.855s.475-.512 1.604-.121c1.129.39 1.257.428 1.257.428s-1.98-.407-2.58.058c-.601.465 1.608 1.4 1.608 1.4s-3.492-.993-3.893-1.35c-.4-.358-.499-1.204-1.336-1.196-.838.01-1.824.52-1.824.52s1.294-1.334 1.855-1.182c.56.152.898.219 1.339.61.441.39.838.798.838.798z",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M241.022 138.37c.338 1.788-1.634 3.717-4.402 4.309-2.768.591-5.283-.38-5.617-2.168-.338-1.787 1.633-3.716 4.401-4.308 2.768-.591 5.284.38 5.618 2.167z",
    fill: "#0f6545",
    stroke: "#000",
    strokeWidth: 0.719,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M234.753 138.078c.081.434-.347.89-.956 1.02-.61.13-1.17-.115-1.25-.548-.082-.433.346-.89.955-1.02.61-.13 1.17.115 1.25.548z",
    fill: "#cecfc1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M280.14 140.533c-.51 1.74-3.108 2.42-5.802 1.518-2.693-.902-4.46-3.044-3.947-4.783.51-1.74 3.108-2.42 5.802-1.518 2.693.902 4.46 3.044 3.947 4.783z",
    fill: "#0f6545",
    stroke: "#000",
    strokeWidth: 0.719,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M274.776 137.06c-.124.421-.705.602-1.298.403-.593-.198-.973-.7-.849-1.122.124-.422.705-.603 1.298-.404.593.198.973.701.849 1.123z",
    fill: "#cecfc1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f2d86",
    stroke: "#000",
    strokeWidth: 1.023,
    strokeLinejoin: "round",
    d: "M250.603 134.34h10.14v5.452h-10.14z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M254.877 135.502c0 .246-.432.446-.964.446s-.963-.2-.963-.446c0-.247.431-.447.963-.447s.964.2.964.447z",
    fill: "#707c8b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M221.944 139.792l1.676 5.274-3.1 1.787s-1.425 1.073-2.85.269c-1.424-.805-2.264-3.214-1.508-4.202 1.501-1.958 5.782-3.217 5.782-3.128z",
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.539
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M219.347 143.546c0 .89-.638 1.61-1.425 1.61s-1.425-.72-1.425-1.61c0-.889.638-1.61 1.425-1.61s1.425.721 1.425 1.61z",
    fill: "#8f322f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M217.999 142.916c.044.284-.019.565-.163.736-.145.17-.35.207-.538.094-.189-.114-.331-.358-.374-.642-.044-.284.018-.565.163-.736a.4.4 0 0 1 .538-.094c.188.113.33.358.374.642z",
    fill: "#e2a494"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M289.88 140.478l-1.665 4.697 3.947 2.206s1.745.83 2.846-.2c.941-.882 1.155-2.922.403-3.953-.712-.976-5.585-2.778-5.531-2.75z",
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.539
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M294.605 144.245c0 .577-.565 1.045-1.262 1.045-.696 0-1.261-.468-1.261-1.045 0-.578.565-1.046 1.261-1.046.697 0 1.262.468 1.262 1.046z",
    fill: "#aa675d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M293.397 144.087c0 .277-.112.532-.295.67a.473.473 0 0 1-.591 0c-.183-.138-.296-.393-.295-.67 0-.276.112-.532.295-.67a.473.473 0 0 1 .591 0c.183.138.295.394.295.67z",
    fill: "#e2a494"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M264.55 134.806a.72.72 0 0 1-.713.727.72.72 0 0 1-.714-.727.72.72 0 0 1 .714-.727.72.72 0 0 1 .713.727zm4.315.265a.72.72 0 0 1-.714.727.72.72 0 0 1-.713-.727.72.72 0 0 1 .713-.726.72.72 0 0 1 .714.726zm-2.187 1.789a.905.905 0 0 1-.897.913.905.905 0 0 1-.897-.914c0-.504.401-.913.897-.913s.898.409.897.913zm2.082 3.002a.72.72 0 0 1-.714.727.72.72 0 0 1-.713-.727.72.72 0 0 1 .713-.727.72.72 0 0 1 .714.727zm-4.164-.572a.72.72 0 0 1-.713.726.72.72 0 0 1-.714-.726.72.72 0 0 1 .714-.727.72.72 0 0 1 .713.727zM243.729 135.59a.745.745 0 0 1-.542.88.696.696 0 0 1-.849-.537.745.745 0 0 1 .542-.88.696.696 0 0 1 .849.537zm4.259-.78a.745.745 0 0 1-.541.88.696.696 0 0 1-.85-.537.745.745 0 0 1 .542-.88.696.696 0 0 1 .849.537zm-1.752 2.268a.937.937 0 0 1-.68 1.106.875.875 0 0 1-1.068-.675.937.937 0 0 1 .68-1.106.875.875 0 0 1 1.068.675zm2.664 2.424a.745.745 0 0 1-.542.88.696.696 0 0 1-.85-.536.745.745 0 0 1 .542-.88.696.696 0 0 1 .85.536zm-4.179.444a.745.745 0 0 1-.541.88.696.696 0 0 1-.849-.536.745.745 0 0 1 .541-.88.696.696 0 0 1 .85.536zM225.54 139.777a.76.76 0 0 1-.418.953.683.683 0 0 1-.912-.402.76.76 0 0 1 .419-.953.683.683 0 0 1 .912.402zm4.113-1.418a.76.76 0 0 1-.419.953.683.683 0 0 1-.912-.402.76.76 0 0 1 .419-.953.683.683 0 0 1 .912.402zm-1.432 2.511a.954.954 0 0 1-.526 1.198.859.859 0 0 1-1.146-.506.954.954 0 0 1 .526-1.198.859.859 0 0 1 1.146.506zm2.959 1.995a.76.76 0 0 1-.418.953.683.683 0 0 1-.912-.402.76.76 0 0 1 .419-.953.683.683 0 0 1 .912.402zm-4.075 1.074a.76.76 0 0 1-.419.953.683.683 0 0 1-.912-.402.76.76 0 0 1 .419-.953.683.683 0 0 1 .912.402zM283.283 137.667a.748.748 0 0 1-.921.566.804.804 0 0 1-.572-.956.748.748 0 0 1 .921-.566.804.804 0 0 1 .572.956zm4.452 1.458a.748.748 0 0 1-.922.565.804.804 0 0 1-.572-.956.748.748 0 0 1 .922-.565.804.804 0 0 1 .572.956zm-2.718 1.272a.94.94 0 0 1-1.158.711 1.01 1.01 0 0 1-.72-1.201.94.94 0 0 1 1.159-.711c.518.136.84.674.719 1.201zm1.457 3.713a.748.748 0 0 1-.922.565.804.804 0 0 1-.572-.956.748.748 0 0 1 .922-.566.804.804 0 0 1 .572.956zm-4.22-1.739a.748.748 0 0 1-.921.566.804.804 0 0 1-.573-.956.748.748 0 0 1 .922-.565.804.804 0 0 1 .572.955z",
    fill: "#f5d8bc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M291.973 94.86s-2.05 2.051-4.487 2.051c-2.436 0-3.846-1.094-4.615-1.64-.77-.548.256-2.189.256-2.189",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.239
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M248.896 98.962s-3.718-.683-5.257-1.23c-1.538-.547-1.153-1.641-2.948-1.505-1.795.137-3.59 1.505-3.206 3.42.385 1.914 1.667 2.187 2.95 1.777 1.281-.41.897-2.735-.77-2.598-1.667.136-.256 1.64-.256 1.64",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.131
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M223.255 95.954s1.025 1.64 3.718 1.367c2.692-.273 3.718-1.777 3.846-2.461.128-.684 0-1.915-.513-2.462-.513-.547-2.308-.82-2.308-.82",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.077
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#161111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.993 169.001c1.555-1.53 4.054-3.223 5.442-6.905 1.3-3.446 1.93-9.77 3.116-12.976 1.55-5.495 4.671-10.853.956-10.486-3.538.35-4.682 3.767-6.022 6.268-.621.932-2.052 2.927-2.322 4.061-.055-1.903-1.016-7.454-1.213-13.036-.183-5.213-.035-10.639-.174-12.664-.171-2.673-.153-5.185-.78-7.16-.293-.921-1.646-1.807-2.34-1.768-1.425.01-2.288 1.25-2.48 2.416-.139.92-.1.584-.194 1.774-.12 1.506.028 3.446-.08 5.15-.117 1.837.123 3.878.023 5.587-.202 3.446-.451 6.604-.553 7.25 0-1.278-.584-7.315-.78-13.045a419.48 419.48 0 0 1-.163-6.313c-.03-1.615.04-3.331-.134-4.586-.295-2.14-.987-3.114-2.54-3.114-1.046 0-2.545.762-3.024 3.142-.259 1.282-.27 2.854-.227 4.568.04 1.594.125 3.311.099 5.036-.097 6.528-.213 13.446-.479 15.484-.043-.67-.696-4.085-.872-8.658a804.67 804.67 0 0 0-.264-6.052c-.116-2.485-.106-4.337-.168-5.995-.018-1.001-.416-3.882-2.343-3.709-1.011-.124-2.083.581-2.514 3.308-.24 1.518-.234 4.133-.274 6.147-.076 3.825-.241 7.174-.058 10.58.115 2.124.097 3.762.121 4.809.026.278-.542-1.785-.83-4.59-.28-2.743-.528-6.234-.506-5.429 0-1.417-.068-3.525-.196-5.265-.1-1.36-.037-2.859-1.512-2.739-1.496.122-2.414.627-2.724 3.189-.2 1.66-.255 5.246-.299 6.547.161 3.307-.723 11.019-1.123 13.211-.11 1.554-.723 3.575-.982 5.741-.558 4.662-.027 10.12.59 12.913 1.227 4.41 4.43 6.39 4.268 9.382-.16 2.992 0 8.269 0 10.631 0 2.363 2.052 2.49 6.301 1.575 6.946-1.496 10.742 1.496 16.478-.709-.728-6.536.69-10.466.653-12.828zm-4.053-15.445c1.437-3.966 3.252-5.524 5.003-6.39",
    fill: "#c00",
    transform: "matrix(1.6 0 0 1.70667 -224 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.145 149.468c2.163-.854 4.41-1.473 6.608-2.224 2.69-.76 5.294-1.847 8.07-2.277 1.338-.272 2.682-.536 4.046-.628m-22.582 26.291c.302-.2.594.117.885.177.407.126.834.252 1.263.178a66.89 66.89 0 0 1 2.534.003c1.002-.037 1.832-.073 2.638-.64m6.276.384c.29.238.62.425.968.563.537.237 1.124.267 4.605-.013 2.16.138 4.071-1.726 4.61-2.23",
    fill: "none",
    transform: "matrix(1.6 0 0 1.70667 -224 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbNir);
export default __webpack_public_path__ + "static/media/gb-nir.2ee6387222698b20e4ec49f93f0dfaa6.svg";
export { ForwardRef as ReactComponent };